<template>
  <div v-if="displayable" class="usable-profile-link-area">
    <!-- FIXME(gift_card_preview_optional): ABテスト gift_card_preview_optional のB群（ギフトカード作成画面）専用のコンポーネント。ABテスト決着後、不要なら削除する -->
    <div class="usable-profile-link-area__switch-area">
      <span class="usable-profile-link-area__label">
        相手にプロフィールリンクを表示
      </span>
      <div class="usable-profile-link-area__switch">
        <ToggleSwitch
          :value="value"
          @change-toggle-switch-value="onChangeToggle"
        />
      </div>
    </div>
    <a class="usable-profile-link-area__link-area" @click="showModal">
      <AlertCircleOutline />
      <span class="usable-profile-link-area__link-text">
        設定についての詳細
      </span>
    </a>
    <div class="usable-profile-link-area__note">
      ※
      プロフィール公開中の場合、ONにするとこのギフトカード上の「贈り主名」がプロフィール画面へのリンクになります
    </div>
    <ProfileLinkModal
      v-if="modalDisplayable"
      preview-optional
      @clicked-modal-cover="hideModal"
      @clicked-close="hideModal"
    />
    <input
      type="hidden"
      name="gift_card_form[usable_profile_link]"
      :value="value"
    />
  </div>
  <input
    v-else
    type="hidden"
    name="gift_card_form[usable_profile_link]"
    :value="value"
  />
</template>

<script setup>
import { ref } from 'vue'
import ToggleSwitch from '../../atoms/toggle_switch/ToggleSwitch.vue'
import AlertCircleOutline from '../../atoms/svg_icons/AlertCircleOutline.vue'
import ProfileLinkModal from '../modals/profileLink/ProfileLinkModal.vue'

defineProps({
  displayable: {
    type: Boolean,
    required: false,
    default: false
  },
  value: {
    type: Boolean,
    required: false,
    default: false
  }
})

const emit = defineEmits(['change'])

const modalDisplayable = ref(false)

const onChangeToggle = () => {
  emit('change')
}
const showModal = () => {
  modalDisplayable.value = true
}
const hideModal = () => {
  modalDisplayable.value = false
}
</script>

<style lang="scss" scoped>
.usable-profile-link-area {
  &__switch-area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
  }

  &__label {
    @extend %body-bold;
    text-align: left;
  }

  &__switch {
    width: 34px;
    height: 20px;
  }

  &__link-area {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 8px;
    cursor: pointer;
  }

  &__link-text {
    @extend %hint;
    color: $link;
  }

  &__note {
    @extend %minimal;
    padding: 8px;
    border-radius: 4px;
    background-color: $gray-3;
    border: 1px solid $gray-2;
    text-align: left;
  }
}
</style>
